'use strict';
import angular from 'angular';

angular.module('app.services')

    .factory('ServiceService', function(TapOrdersServiceFactory, $q) {
        var service = {};
        service.service = null;

        // Add a single comment on multiple tasks
        service.getService = function(serviceId) {
            var deferred = $q.defer();
            var params = {
                'serviceId': serviceId
            };

            TapOrdersServiceFactory.service().get(params).$promise.then(function(data) {
                service.service = data.service;
                deferred.resolve();
            }, function(response) {
                deferred.reject();
            });

            return deferred.promise;
        };

        return service;
    })

    .factory('TapOrdersServiceFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
        var factory = {};

        factory.service = function() {
            return $resource(AppConfig.IO_API_URL + 'serviceConnections/service', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        return factory;
    }]);
